<template>
  <div
    class="w-full h-[70px] font-primary text-[14px] leading-[18px] text-gray-800 border-b border-[#DFDFDF] flex items-center"
  >
    <div class="w-full flex justify-between">
      <slot name="left" />
      <slot name="right" />
    </div>
  </div>
</template>
